'use strict'

var service = require('./service')

module.exports = stripeProvider

stripeProvider.$inject = ['Stripe']
function stripeProvider (Stripe) {
  if (!Stripe) throw new Error('Stripe must be available as window.Stripe')
  this.setPublishableKey = Stripe.setPublishableKey
  this.$get = service
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-stripe/src/provider.js
 ** module id = 341
 ** module chunks = 0
 **/